<template>
    <div class="group relative bg-transparent select-none"
        @click.stop="toggleOpen"
    >
        <div class="flex h-10 pl-8 pr-4 bg-transparent hover:bg-blue-50">
            <div class="flex flex-1 items-center leading-tight text-sm"
                 :class="is_open ? 'text-blue-600' : 'text-gray-600 group-hover:text-blue-600'"
            >
                <!-- Disclosure Triangle -->
                <div class="w-4 flex-none flex items-center justify-center mr-2">
                    <span v-if="is_open">
                        <chevron-down-icon size="16" class="text-gray-600" />
                    </span>
                    <span v-else>
                        <chevron-right-icon size="16" class="text-gray-400 group-hover:text-blue-600" />
                    </span>
                </div>

                <div class="flex flex-1 items-center justify-between">
                    <div class="flex items-center">
                        <div>
                            {{ name }}
                        </div>

                        <div v-if="document_count"
                              :class="[
                                  'bg-blue-500 text-white font-semibold ml-2 hidden rounded-full px-2 py-0.5 text-xs font-medium md:inline-block'
                              ]">
                            {{ document_count }}
                        </div>
                    </div>

                    <input-file
                        v-if="! is_template && !hide_upload_button"
                        :store_url="store_route"
                        :parameters="{ folder: folder_id }"
                        :button="true"
                        @uploaded="documentUploaded"
                    />
                </div>
            </div>
        </div>

        <div v-if="is_open"
            class="pl-14 pr-4"
            @click.stop
        >
            <div :ref="`fileContainer-${folder_id}`"
                class="file-sortable-container"
                :data-folder-id="folder_id"
            >
                <!-- Show documents if this is the Documents subfolder -->
                <documents-entry v-for="(document, index) in documents"
                    v-if="! is_template"
                    :key="`document-${document.id}`"
                    :index="index"
                    :count="documents.length"
                    :document="document"
                    :signatures_enabled="has_active_docusign_user"
                    :has_templates="has_templates"
                    :selection_mode="selection_mode"
                    :selected_documents="selected_documents"
                    :disable_contextual_menus="disable_contextual_menus"
                    :is_editable="is_editable"
                    @edited="documentEdited"
                    @deleted="documentDeleted"
                    @selection-changed="handleSelectionChanged"
                />

                <!-- Show templates if this is the Templates subfolder -->
                <documents-template-entry v-for="(template, index) in documents"
                    v-if="is_template"
                    :key="`template-${template.id}`"
                    :index="index"
                    :count="documents.length"
                    :template="template"
                    :selection_mode="selection_mode"
                    :selected_documents="selected_documents"
                    :disable_contextual_menus="disable_contextual_menus"
                    :is_editable="is_editable"
                    @selection-changed="handleSelectionChanged"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { ChevronRightIcon, ChevronDownIcon } from 'vue-feather-icons';
import DocumentsEntry from './documents-entry.vue';
import DocumentsTemplateEntry from './documents-template-entry.vue';
import InputFile from '../../components/input-file.vue';

export default {
    components: {
        ChevronDownIcon,
        ChevronRightIcon,
        DocumentsEntry,
        DocumentsTemplateEntry,
        InputFile,
    },

    props: {
        name: {},
        documents: {},
        folder_id: {},
        property_id: {},
        has_active_docusign_user: {},
        store_route: {},
        is_template: {},
        has_templates: {},
        selection_mode: { default: false },
        selected_documents: { default: () => [] },
        hide_upload_button: { default: false },
        disable_contextual_menus: { default: false },
        is_editable: { default: true },
    },

    data() {
        return {
            is_dropping: false,
            is_open: true,
        }
    },

    computed: {
        document_count() {
            return this.documents?.length;
        },
    },

    methods: {
        toggleOpen() {
            this.is_open = ! this.is_open;
        },
        documentEdited(updatedDocument) {
            this.$emit('documentEdited', updatedDocument);
        },
        documentDeleted(id) {
            this.$emit('documentDeleted', id);
        },
        documentUploaded(document) {
            this.$emit('documentUploaded', document);
        },
        handleSelectionChanged(selected) {
            this.$emit('selection-changed', selected);
        },
    },
}
</script>
